import { createFileRoute } from "@tanstack/react-router";

import { OrganizationSettingsPanel } from "../components/settings/OrganizationSettings";

function SettingsOrganizationRoute() {
  return <OrganizationSettingsPanel />;
}

export const Route = createFileRoute("/settings/organization")({
  component: SettingsOrganizationRoute,
});
